export const WORLD_SIZE = 512;



// WEBPACK FOOTER //
// ./src/app/common/layers/constants.ts